import { PipeTransform } from '@angular/core';
var GetIconPipe = /** @class */ (function () {
    function GetIconPipe() {
    }
    GetIconPipe.prototype.transform = function (attachment) {
        var filename = attachment.filename;
        var extension = filename.split('.').pop();
        switch (extension) {
            case 'jpg':
            case 'jpeg':
            case 'png':
                return attachment.thumb || 'assets/mat-icon/image.svg';
            case 'pdf':
                return 'assets/mat-icon/pdf.svg';
            case 'doc':
            case 'docx':
                return 'assets/mat-icon/word.svg';
            case 'xls':
            case 'xlsx':
                return 'assets/mat-icon/excel.svg';
            case 'ppt':
            case 'pptx':
                return 'assets/mat-icon/slide.svg';
            case 'csv':
                return 'assets/mat-icon/csv.svg';
            case 'txt':
                return 'assets/mat-icon/vector.svg';
            default:
                return 'assets/images/icons/file_icon.svg';
        }
    };
    return GetIconPipe;
}());
export { GetIconPipe };
